import { displayShortDate } from '../../utils/Format/Format';
import { isTacked, isUnsupportedByMorningstar } from '../../utils/fund-info';

export const morningStarCategoryUtil = (ticker, iClass) => (gqlResult) => {
    if (!gqlResult) return null;
    const {
        mutualFund: { inceptionDate, morningStarRatings }
    } = gqlResult;

    const {
        morningStarOverallRating,
        morningStar3YearRating,
        morningStar5YearRating,
        morningStar10YearRating,
        morningStarOverallQuantity,
        morningStar3YearQuantity,
        morningStar5YearQuantity,
        morningStar10YearQuantity,
        morningStarAsOfDate,
        morningStarCategoryName: categoryName
    } =
        morningStarRatings || {};

    const asOfDate =
        (morningStarAsOfDate && displayShortDate(morningStarAsOfDate)) || 'N/A';

    const tackedFundThreeYr = isTacked(iClass, inceptionDate, 3);

    const title = `Morningstar Ratings ${tackedFundThreeYr ? '◊' : ''}`;

    const categoryTitle = 'MORNINGSTAR CATEGORY';

    const returnData = [
        {
            label: `Overall ${
                morningStarOverallQuantity
                    ? `(out of ${morningStarOverallQuantity} funds)`
                    : '(N/A)'
            }`,
            values: [{ val1: morningStarOverallRating }]
        },
        {
            label: `3 Year ${
                morningStar3YearQuantity
                    ? `(out of ${morningStar3YearQuantity} funds)`
                    : '(N/A)'
            }`,
            values: [
                {
                    val1: tackedFundThreeYr ? 0 : morningStar3YearRating
                }
            ]
        },
        {
            label: `5 Year ${
                morningStar5YearQuantity
                    ? `(out of ${morningStar5YearQuantity} funds)`
                    : '(N/A)'
            }`,
            values: [
                {
                    val1: isTacked(iClass, inceptionDate, 5)
                        ? 0
                        : morningStar5YearRating
                }
            ]
        },
        {
            label: `10 Year ${
                morningStar10YearQuantity
                    ? `(out of ${morningStar10YearQuantity} funds)`
                    : '(N/A)'
            }`,
            values: [
                {
                    val1: isTacked(iClass, inceptionDate, 10)
                        ? 0
                        : morningStar10YearRating
                }
            ]
        }
    ];
    return {
        data: returnData,
        categoryTitle,
        categoryName,
        title,
        asOfDate,
        shouldHide:
            !morningStarOverallQuantity || isUnsupportedByMorningstar(ticker),
        tacked: tackedFundThreeYr
    };
};
